import { Component, OnInit, Injector } from '@angular/core';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';
import { UserService } from 'src/app/services/user/user.service';
import { UserModel } from 'src/app/models/auth/user.model';
import { AuthenticationService } from 'src/app/services/user/authentication.service';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PrimeNGConfig } from 'primeng/api';
import { TR_LOCALE, EN_LOCALE } from 'src/app/shared/locale.config';
import { ChangeLanguageService } from 'src/app/services/change-language.service';

@Component({
  selector: 'app-admin-dialog',
  templateUrl: './admin-dialog.component.html',
  styleUrls: ['./admin-dialog.component.scss']
})
export class AdminDialogComponent extends BaseFormComponentComponent implements OnInit {

  referenceNo: string;
  foundedUser: UserModel = null;
 

  constructor(protected injector: Injector, public ref: DynamicDialogRef, public config: DynamicDialogConfig,
     private userService: UserService, private auth: AuthenticationService, private router: Router,
    private primengConfig: PrimeNGConfig, private languageService: ChangeLanguageService) {
     super(injector)
  }

  async searchUserByRefNo(form) {
    
    this.foundedUser = null;

    if(!this.referenceNo) return;

    try {
      this.isLoading = true;
      this.foundedUser = await this.userService.getByReferenceNo(this.referenceNo).toPromise();
      this.isLoading = false;
    } catch ( e ) {
      this.isLoading = false;
    }
    
  }

  loginWithAdmin() {
    this.ref.close();
    this.router.navigate(['/home']);
  }

  async loginWithUser() {
    if(!this.foundedUser) {
      this.showMessage('warn', 'notSelectedUser');
      return;
    }
    
    try {
        this.isLoading = true;
        const auth = await this.auth.login(this.config.data.loginDTO.email, this.config.data.loginDTO.password, this.referenceNo).toPromise();
        let user = auth.user;
        let token = auth.token;
        localStorage.setItem("token", token);
        localStorage.setItem('user', JSON.stringify(user));

        if(user.locale == 'en-US') {
              this.translation.setDefaultLang('en');
              this.translation.use('en');
              this.primengConfig.setTranslation(EN_LOCALE);
              localStorage.setItem('lang', 'en');
              localStorage.setItem('locale', 'en-US');
              this.languageService.languageChanged.next('en');

        }
        this.isLoading = false;
        this.ref.close();

        this.router.navigate(['/home']);
    } catch(e) {
        this.ref.close();
        this.isLoading = false
    }
 
    
  }
  ngOnInit(): void {
  }

}
